// extracted by mini-css-extract-plugin
var _1 = "YourInvitesModal-module__container___MxPJk";
var _2 = "YourInvitesModal-module__content___Am0YU";
var _3 = "YourInvitesModal-module__heart___HOINT";
var _4 = "YourInvitesModal-module__spacer___z_uYN";
export { _1 as "container", _2 as "content", _3 as "heart", _4 as "spacer" }
